module.exports = __webpack_public_path__ + "static/img/home-register.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home-register.png
// module id = 537
// module chunks = 0